








import FooterLink from '@/views/templates/footer/FooterLink.vue'
import Copyright from '@/views/templates/footer/Copyright.vue'

export default
  name: 'Footer'

  components: {
    FooterLink
    Copyright
  }

  methods: {
    go_top: () ->
      @$emit('go_top')
  }
